import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/contact-management`;

export const contactManagementRoutesObj = {
  list: baseRoute,
} as const;

export type IContactManagementRouteParams = IExtractRouteParamMap<
  typeof contactManagementRoutesObj
>;

export const contactManagementPath = createPaths<
  typeof contactManagementRoutesObj,
  IContactManagementRouteParams
>(contactManagementRoutesObj);
